module.exports = __webpack_public_path__ + "img/9b2918bb0e7c3772044f6cad350c7aa7.png";